import React, { Component } from 'react'
import imgUrl from '../../../../styles/img/enfant-avatar.jpg'
import { API } from "../../../../const";
import { Service } from "../../../../modules/service/service"
import InfiniteScroll from "react-infinite-scroll-component";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import moment from 'moment';
import _ from 'lodash';
import { toUpperCaseFirst } from "../../../../ReactConst";
import { getArchiveOneKid } from './archiveEnfants.ducks'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
function jsUpperCaseFirst(string) {
    return _.isEmpty(string) ? string : string.charAt(0).toUpperCase();
}
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
class ArchiveEnfants extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasMoreItems: true,
            page: [],
            ModaleConfirmationDelete: false,
            kidId: '',
            listKids: [],
            kidsLoading: true,
            scrollLoader: false,
            offset: 1,
            redirect: false,
            idFicheEnfant: ""

        }
        this.loadMore = this.loadMore.bind(this)
        this.handleClickArchive = this.handleClickArchive.bind(this)
    }
    componentDidMount() {
        let tok = localStorage.getItem("token")
        const response = Service.get(`${API}api/enfant/creche/enfants/archives?offset=1&path-size=20`, { headers: { Authorization: `Bearer ${tok}` } })
        response.then((res) => {
            let sortedKids = (res.data.enfants.elements).sort((a, b) => moment(b.dateTime).diff(a.dateTime))
            this.setState({
                listKids: sortedKids,
                kidsLoading: false,
                page: res.data.enfants.pagesNumber,
                totalElements: res.data.enfants.totalElements

            })


        })
    }
    handleClickArchive(data) {
        this.props.getArchiveOneKid(data)

        this.setState({
            redirect: true,
            idFicheEnfant: data.enfant.id
        })
    }
    loadMore() {
        this.setState({
            scrollLoader: true

        })
        if (this.state.listKids.length === this.state.totalElements) {
            this.setState({ hasMoreItems: false })

        }
        else {
            setTimeout(() => {
                let tok = localStorage.getItem("token")
                let offset = this.state.offset + 1

                const response = Service.get(`${API}api/enfant/creche/enfants/archives?offset=${offset}&path-size=20`, { headers: { Authorization: `Bearer ${tok}` } })
                response.then((res) => {
                    let sortedKids = this.state.listKids.concat(res.data.enfants.elements)
                    sortedKids = (sortedKids).sort((a, b) => moment(b.dateTime).diff(a.dateTime))
                    this.setState({
                        listKids: sortedKids,
                        offset: offset,
                        scrollLoader: false
                    })
                })

            }, 500);

        }

    }
    render() {
        const { match } = this.props
        const { t } = this.props;

        var items = [];
        let nameUpperCase = "";
        var divStyle = (lienPhoto) => ({
            backgroundImage: 'url(' + lienPhoto + ')',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        });
        const divStyleScroll = {
            overflow: 'none',
        };
        if (!_.isEmpty(this.state.listKids)) {
            this.state.listKids.map((element, i) => {
                nameUpperCase = jsUpperCaseFirst(element.enfant.nom);

                items.push(
                    <div key={i} className="col-md-3 px-2 mb-3" onClick={() => this.handleClickArchive(element)}>
                        <div className="card card-child card-child-archive">
                            <div className="avatar-child" style={divStyle(element.enfant.lienPhoto)}></div>
                            <div className="card-body">
                                <div className="d-flex justify-content-center align-items-center">
                                    <div className="child-infos text-center">
                                        <h3>{toUpperCaseFirst(element.enfant.prenom) + " " + jsUpperCaseFirst(element.enfant.nom) + "."}</h3>
                                        <div className="infos-archives">
                                            <p><span>{t('creche.archived_on')}</span> {moment(element.dateArchivage).format("DD/MM/YYYY")}</p>
                                            <p><span>{t('creche.expires_on')}</span> {moment(element.dateExpiration).format("DD/MM/YYYY")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
        }
        return (
            <div className="container pt-4">
                {this.state.redirect &&
                    <Redirect to={`${match.url}/${this.state.idFicheEnfant}/identite`} />}
                <InfiniteScroll
                    style={divStyleScroll}
                    dataLength={this.state.listKids.length}
                    next={this.loadMore}
                    hasMore={this.state.hasMoreItems}
                    loader={<div className="content p-0" >
                        <DotLoader
                            size={100}
                            color={"#ff7d26"}
                            css={override}
                            loading={this.state.kidsLoading}

                        />
                    </div>}
                >
                    <div className="tab-pane fade show" id="archives-enfants-pane" role="tabpanel" aria-labelledby="archives-enfants-tab">
                        <div className="content p-0">
                            <div className="row mx-n2">
                                {items}
                            </div>
                        </div>
                    </div>
                </InfiniteScroll>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
    getArchiveOneKid
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ArchiveEnfants));
